import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomerTopTable = ({ data }) => {
    const { t } = useTranslation();
    if (!data || !data.customers || data.customers.length === 0) return null;

    const strings = t('customerAnalytics.tables.topCustomers', { returnObjects: true });
    const customers = data.customers;
    const maxWeight = Math.max(...customers.map(c => parseFloat(c.total_weight_tons) || 0));

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{strings.title}</span>
                    <div style={subtitleStyle}>By weight dispatched this period</div>
                </div>
                <span style={badgeStyle}>{customers.length} customers</span>
            </div>
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                        <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                            <th style={thStyle('left')}>#</th>
                            <th style={thStyle('left')}>{strings.headers.customer}</th>
                            <th style={thStyle('right')}>{strings.headers.orders}</th>
                            <th style={thStyle('right')}>{strings.headers.weightTons}</th>
                            <th style={thStyle('right')}>{strings.headers.lastOrder}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {customers.map((c, i) => {
                            const weight = parseFloat(c.total_weight_tons) || 0;
                            const pct = maxWeight > 0 ? (weight / maxWeight) * 100 : 0;
                            return (
                                <tr
                                    key={c.customer_id || i}
                                    style={{ borderBottom: '1px solid #f9fafb' }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                    <td style={{ ...tdStyle, color: '#9ca3af', fontWeight: 700, width: 36 }}>{i + 1}</td>
                                    <td style={{ ...tdStyle, maxWidth: 280 }}>
                                        <div style={{ fontWeight: 600, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                            title={c.customer_name}>
                                            {c.customer_name}
                                        </div>
                                        {c.company_name && c.company_name !== c.customer_name && (
                                            <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {c.company_name}
                                            </div>
                                        )}
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: 'right', fontWeight: 700, color: '#7c3aed' }}>
                                        {c.total_orders}
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: 'right' }}>
                                        <div style={{ fontWeight: 600, color: '#111827' }}>
                                            {weight.toFixed(3)} T
                                        </div>
                                        <div style={{ height: 3, borderRadius: 2, backgroundColor: '#e5e7eb', marginTop: 4, width: '100%', minWidth: 60 }}>
                                            <div style={{ height: '100%', borderRadius: 2, backgroundColor: '#3b82f6', width: `${pct}%` }} />
                                        </div>
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: 'right', color: '#6b7280', fontSize: 12 }}>
                                        {new Date(c.last_order_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const cardStyle = {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    border: '1px solid #f3f4f6',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    overflow: 'hidden',
};
const headerStyle = {
    padding: '18px 20px 12px',
    borderBottom: '1px solid #f9fafb',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
};
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };
const badgeStyle = {
    fontSize: 11, fontWeight: 700, color: '#7c3aed',
    backgroundColor: '#f5f3ff', borderRadius: 20, padding: '3px 10px',
};
const thStyle = (align) => ({
    padding: '10px 16px',
    textAlign: align,
    fontSize: 11,
    fontWeight: 700,
    color: '#9ca3af',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    backgroundColor: '#fafafa',
    whiteSpace: 'nowrap',
});
const tdStyle = { padding: '10px 16px', verticalAlign: 'middle' };

export default CustomerTopTable;
